import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledDelete = styled.svg<IconProps>`
  & .cls-1,
  .cls-3 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  & .cls-3 {
    stroke: var(--chatbot-color-primary, #404040);
    stroke-miterlimit: 10;
  }

  &.hover:hover,
  &.active {
    .cls-1 {
      fill: none;
    }

    .cls-2,
    .cls-3 {
      fill: var(--du-color-primary, #128370);
    }

    .cls-3 {
      stroke: var(--du-color-primary, #128370);
      stroke-miterlimit: 10;
    }
  }
`;

const DeleteIcon: React.FC<IconProps> = ({ active }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledDelete
      id='Delete-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <g id='Group_8984' data-name='Group 8984'>
        <path id='Path_8862' data-name='Path 8862' className='cls-1' d='M0,0H32V32H0Z' />
        <path id='Lid' className='cls-2' d='M9.509,10.95V9.068h3.2L13.713,8.06h4.573l1.008,1.008h3.2V10.95Z' />
        <path
          id='Bin'
          className='cls-3'
          d='M0,0H10.091a0,0,0,0,1,0,0V10.021a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z'
          transform='translate(10.955 12.47)'
        />
      </g>
    </StyledDelete>
  );
};

export default DeleteIcon;
